angular.module('EdxDistrictReportModule')
  .controller('EdxDistrictReportController', [
    '$scope',
    '$state',
    'edxStateParamsService',
    'districtApi',
    'timeframe',
    function (
      $scope,
      $state,
      edxStateParamsService,
      districtApi,
      timeframe) {

      var params = _.pick($state.params, ['districtId']);
      params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

      // this hightlights call provides the year list for dropdowns
      districtApi.getDistrictHighlights(params).then(function (districtData) {
         timeframe.getYearListSubject().onNext(districtData.years);

         // deprecated: use timeframe.getYearListSubject instead of broadcast
         $scope.$broadcast('updateYears', districtData.years);

         return districtData;
      });
    }
  ]);
